export default __webpack_public_path__ + "static/media/rainy-2.523a54b8.svg";